import { Auth } from "aws-amplify";

const NOSH_API = {
    BASE_URL: "https://nosh.jp/api/amb",
    HEADER: (token) => {
        return {
        };
    },
}

const createToken = async () => {
    const session = await Auth.currentSession();
    const token = session.getAccessToken().getJwtToken();
    return token;
}

export const noshApiRequest = async (url, method, body = null) => {
    const targetUrl = `${NOSH_API.BASE_URL}${url}`;
    const option = {
        method: method,
    }
    if (body) {
        option.body = JSON.stringify(body);
    }
    const res = await fetch(targetUrl, option);
    const data = await res.json();
    return data;
}


